export const verticalBlocks = [
    {
        x: 1800,
        y: 130,
        width: 40,
        height: 80,
        color: '#974e4d',
        scroll_speed: 0.6
    },
    {
        x: 600,
        y: 800,
        width: 30,
        height: 50,
        color: '#f8a897',
        scroll_speed: -0.4
    },
    {
        x: 1500,
        y: 100,
        width: 15,
        height: 35,
        color: '#ced155',
        scroll_speed: -0.5
    },
    {
        x: 1700,
        y: 900,
        width: 20,
        height: 40,
        color: 'pink',
        scroll_speed: -0.4
    }
]